import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=ca3a70d8&scoped=true&"
import script from "./Policies.vue?vue&type=script&lang=js&"
export * from "./Policies.vue?vue&type=script&lang=js&"
import style1 from "./Policies.vue?vue&type=style&index=1&id=ca3a70d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a70d8",
  null
  
)

export default component.exports